import { render, staticRenderFns } from "./AssistantView.vue?vue&type=template&id=512e5488"
import script from "./AssistantView.vue?vue&type=script&lang=js"
export * from "./AssistantView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports